import * as React from "react";
import { Input } from "./widget";
import { bind, Control, ControlProps } from "./Control";
import { asDate } from "../state/types";

const DateInput = (props: ControlProps) => {
    const id = props.name;
    const binding = bind(props);
    const date = asDate(binding.value);
    const isoDate = date?.toISOString();
    const value = isoDate?.slice(0, 10);

    return <Control {...props}>
        <Input
            type="date"
            autoFocus={props.autoFocus}
            name={id}
            inputProps={{ min: "0001-01-01", max: "9999-12-31" }}
            id={id}
            placeholder={props.placeholder}
            value={value || ''}
            onChange={e => binding.onChange(Date.parse(e.currentTarget.value))} />
    </Control>;
}

export {
    DateInput
};